import { IPatientIdentity } from 'interfaces/familyBookingTypes';

export const getPatientKey = (patient: IPatientIdentity) =>
  patient.id ||
  `${patient.email}-${patient.dob}-${patient.firstName}-${patient.lastName}`.toLowerCase();
